module.exports = require("electron");


/*****************
 ** WEBPACK FOOTER
 ** external "electron"
 ** module id = 14
 ** module chunks = 0
 **/